import {HistoryDetail} from './detail';
import {HistoryList} from './list';

export {HistoryDetail, HistoryList};
